import { captureEvent, captureException } from '@sentry/browser'
import React from 'react'

interface Props {
  fallback: React.ReactNode
  additionalDebugData?: string
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: unknown, info: { componentStack: unknown }) {
    captureException(error, {
      extra: { componentStack: info?.componentStack, additionalDebugData: this.props.additionalDebugData },
    })
    if (this.props.additionalDebugData) {
      captureEvent({ message: this.props.additionalDebugData })
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback
    }

    return this.props.children
  }
}
